// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomTooltip_tooltip__1LL3W","text":"CustomTooltip_text__mEw+i"};